<template lang="pug">
.ladder-blend-coupon-contioner
  .ladder-line-one
    .top-icon 特权1
    div(style='display:flex;margin-top:-0.03rem')
      div 生活出行卡券·领
      div.red-word {{propsList.length}}张券
  .coupon-group(v-for="(coupons,index) in couponList")
    template(v-if="index <=1 || isOpenFlag")
      .coupon-title-container
        .divider
        .coupon-title
          img(v-if="coupons.icon" :src="coupons.icon")
          span(:class="{'bold':coupons.freeCouponsFlag?false:true}") {{coupons.title}}
          span {{coupons.freeCouponsFlag?'':'完单后，解锁更多券'}}
      .coupon-tab
        couponsItems(v-for="(item,index) in coupons.coupons.slice(0,4)"
          :cardInfo="item"
          :cardBackground="getBackGround(item.multiFlag)"
          cardWidth="0.78rem"
          cardHeight="1.06rem"
          :index="index"
          cardClass="ladder-blend")
  .more-coupons-bar.flex-mid(
    @click="changeOpenFlag"
    v-if="couponList && couponList.length>2 && !isOpenFlag")
    span 更多优惠券
    img(src="https://m.hellobike.com/resource/helloyun/22042/FtlPpVNDAq.png?x-oss-process=image/quality,q_80")
  </template>
<script>
import { getNoScroll } from '@/utils';
import lifeCardBussiness from './life-card-bussiness.vue';
import couponsItems from './coupons-Items.vue';
import { groupByLadderArray, couponsData } from '../utils';


export default {
  components: {
    lifeCardBussiness,
    couponsItems,
  },
  props: {
    groupList: {
      type: Array,
      required: true,
    },
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    newCustomer: {
      type: Boolean,
      default: true,
    },
    allPropList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      lifeList: [],
      bussinessList: [],
      couponList: [],
      tempObj: {},
      isOpenFlag: false,
    };
  },
  inject: ['getPropVersion'],

  computed: {
    propsList() {
      return couponsData(this.allPropList, this.getPropVersion ? this.getPropVersion() : '');
    },
  },
  mounted() {
    this.handleCouponList();
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    changeOpenFlag() {
      this.isOpenFlag = true;
    },
    getBackGround(multiFlag) {
      if (multiFlag) {
        return 'https://m.hellobike.com/resource/gallery/43/agqcVPsFMT.png';
      }
      return 'https://m.hellobike.com/resource/gallery/43/2RFmiHU89r.png';
    },
    handleCouponList() {
      const freeCoupons = {
        title: this.newCustomer ? '开卡全领，一单回本' : '开卡全领，越用越省',
        coupons: this.groupList[0].coupons.slice(0, 4),
        freeCouponsFlag: true,
      };
      const handledBusCoupons = this.ladderPropGroupList.map((busCoupons) => {
        const { coupons, groupCode } = busCoupons;
        const busCoupon = groupByLadderArray(coupons);
        const busDescObj = this.ladderDetailMap[groupCode] || { businessLineIcon: '', businessLineName: '' };
        const { businessLineIcon, businessLineName } = busDescObj;
        // 多业务线券显示业务线，单业务线的显示券描述
        const busHandleCoupon = busCoupon.map((item) => ({
          ...item,
          goodsPropDesc: item.multiFlag ? businessLineName : item.goodsPropDesc,
        }));
        return { title: businessLineName, icon: businessLineIcon, coupons: busHandleCoupon };
      });
      this.couponList = [freeCoupons, ...handledBusCoupons];
    },
    open() {
      this.show = true;
    },
    close() {
      this.$emit('update:show', false);
      this.show = false;
      getNoScroll(false);
    },
  },
};
</script>
<style lang="less" scoped>
.ladder-blend-coupon-contioner {
  background: #fff;

  .ladder-line-one {
    padding: 0 0.15rem;
    color: #242729;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.15rem;
    font-weight: 500;
    display: flex;
    line-height: 0.22rem;
    margin-top: -0.03rem;

    .red-word {
      color: #f54311;
      font-weight: 700;
    }

    .top-icon {
      background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
      height: 0.18rem;
      border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
      color: #fffae8;
      font-size: 0.12rem;
      text-align: center;
      line-height: 0.18rem;
      padding: 0 0.05rem;
      margin-right: 0.05rem;
    }
  }

  .more-coupons-bar {
    height: 0.14rem;
    width: 100%;
    margin-top: 0.116rem;

    span {
      color: #879099;
      font-family: "PingFang SC", sans-serif;
      font-size: 0.12rem;
      line-height: 0.14rem;
    }

    img {
      width: 0.12rem;
      height: 0.12rem;
    }
  }

  .coupon-group {
    padding: 0 0.12rem 0;

    .coupon-title-container {
      margin: 0.08rem 0;
      height: 0.32rem;
      line-height: 0.32rem;
      position: relative;
      width: 100%;
      display: flex;
      justify-content: center;

      .divider {
        width: 100%;
        height: 0.01rem;
        background-color: #ebebeb;
        position: absolute;
        left: 0;
        top: 50%;
      }

      .coupon-title {
        width: fit-content;
        color: #373b3e;
        font-family: "PingFang SC", sans-serif;
        font-weight: 500;
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        z-index: 1;
        position: relative;
        padding: 0 0.08rem;

        img {
          height: 0.15rem;
          object-fit: contain;
          margin-right: 0.05rem;
        }

        span {
          opacity: 0.7;
          font-weight: 400;
        }

        .bold {
          font-weight: 600;
        }
      }
    }

    .coupon-tab {
      display: flex;
    }
  }
}
</style>
